import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
/**
 *
 * Note: if there's an overlapping error for a particular field this is the order in which they'll be displayed
 * form level
 * section level
 * field level
 * base level: same level as "field", but uses built int zod validations
 */
// eslint-disable-next-line
export const sectionKConsistency = ({ input, ctx, version, isSection, field }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc'); // args here doesn't have a purpose
    if (!isSection && !field) {
        // form level
        // eslint-disable-next-line
        const payload = input;
    }
    else if (!field) {
        // section level
        // eslint-disable-next-line
        const payload = input;
    }
    else {
        // field level
        if (field === 'k0520') {
            if (!input) {
                return;
            }
            const p = input;
            // K-consistency-5930: column 1 (SOC/ROC — on admission)
            // Only fire when column 1 sub-items are present
            if (p.a1 !== undefined || p.z1 !== undefined) {
                // (a) If K0520Z1=[1], then all active items from K0520A1 through K0520D1 must equal [0].
                if (p.z1 && (p.a1 || p.b1 || p.c1 || p.d1)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-5930 (a) If 'None of the above' is checked, then items A through D must not be checked`,
                        path: [],
                    });
                }
                // (b) If K0520Z1=[0], then at least one active item from K0520A1 through K0520D1 must equal [1].
                if (!p.z1 && !p.a1 && !p.b1 && !p.c1 && !p.d1) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-5930 (b) At least one item from A through D must be checked, or select 'None of the above'`,
                        path: [],
                    });
                }
            }
            // K-consistency-5940: column 4 (DSCH — last 7 days)
            // Only fire when column 4 sub-items are present
            if (p.a4 !== undefined || p.z4 !== undefined) {
                // (a) If K0520Z4=[1], then all active items from K0520A4 through K0520D4 must equal [0].
                if (p.z4 && (p.a4 || p.b4 || p.c4 || p.d4)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-5940 (a) If 'None of the above' is checked for last 7 days, then items A through D must not be checked`,
                        path: [],
                    });
                }
                // (b) If K0520Z4=[0], then at least one active item from K0520A4 through K0520D4 must equal [1].
                if (!p.z4 && !p.a4 && !p.b4 && !p.c4 && !p.d4) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-5940 (b) At least one item from A through D must be checked for last 7 days, or select 'None of the above'`,
                        path: [],
                    });
                }
            }
            // K-consistency-5950: column 5 (DSCH — at discharge)
            // Only fire when column 5 sub-items are present
            if (p.a5 !== undefined || p.z5 !== undefined) {
                // (a) If K0520Z5=[1], then all active items from K0520A5 through K0520D5 must equal [0].
                if (p.z5 && (p.a5 || p.b5 || p.c5 || p.d5)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-5950 (a) If 'None of the above' is checked at discharge, then items A through D must not be checked`,
                        path: [],
                    });
                }
                // (b) If K0520Z5=[0], then at least one active item from K0520A5 through K0520D5 must equal [1].
                if (!p.z5 && !p.a5 && !p.b5 && !p.c5 && !p.d5) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-5950 (b) At least one item from A through D must be checked at discharge, or select 'None of the above'`,
                        path: [],
                    });
                }
            }
        }
    }
};
// K-consistency-5930
// (a) If K0520Z1=[1], then all active items from K0520A1 through K0520D1 must equal [0].
// (b) If K0520Z1=[0], then at least one active item from K0520A1 through K0520D1 must equal [1], and the remaining items must equal [0,1].
// (c) If K0520Z1=[-], then at least one active item from K0520A1 through K0520D1 must equal [-], and the remaining items must equal [0,-].
// K-consistency-5940
// (a) If K0520Z4=[1], then all active items from K0520A4 through K0520D4 must equal [0].
// (b) If K0520Z4=[0], then at least one active item from K0520A4 through K0520D4 must equal [1], and the remaining items must equal [0,1].
// (c) If K0520Z4=[-], then at least one item from K0520A4 through K0520D4 must equal [-], and the remaining active items must equal [0,-].
// K-consistency-5950
// (a) If K0520Z5=[1], then all active items from K0520A5 through K0520D5 must equal [0].
// (b) If K0520Z5=[0], then at least one active item from K0520A5 through K0520D5 must equal [1], and the remaining items must equal [0,1].
// (c) If K0520Z5=[-], then at least one active item from K0520A5 through K0520D5 must equal [-], and all remaining active items must equal [0,-].
